export const COMPTEUR = {
    SET_STEP: 'SET_STEP',
    SET_RAISON_SOCIALE: 'SET_RAISON_SOCIALE',
    SET_NOM_COMMERCIAL: 'SET_NOM_COMMERCIAL',
    SET_NUMERO_IDENTIFICATION: 'SET_NUMERO_IDENTIFICATION',
    SET_ADRESSE_POSTALE: 'SET_ADRESSE_POSTALE',
    SET_CODE_POSTAL: 'SET_CODE_POSTAL',
    SET_VILLE: 'SET_VILLE',
    SET_CIVILITE: 'SET_CIVILITE',
    SET_NOM_REPRESENTANT: 'SET_NOM_REPRESENTANT',
    SET_PRENOM_REPRESENTANT: 'SET_PRENOM_REPRESENTANT',
    SET_DATE_NAISSANCE_REPRESENTANT: 'SET_DATE_NAISSANCE_REPRESENTANT',
    SET_MAIL_REPRESENTANT: 'SET_MAIL_REPRESENTANT',
    SET_ADRESSE_REPRESENTANT_IDENTIQUE: 'SET_ADRESSE_REPRESENTANT_IDENTIQUE',
    SET_ADRESSE_POSTALE_REPRESENTANT: 'SET_ADRESSE_POSTALE_REPRESENTANT',
    SET_CODE_POSTAL_REPRESENTANT: 'SET_CODE_POSTAL_REPRESENTANT',
    SET_VILLE_REPRESENTANT: 'SET_VILLE_REPRESENTANT',
    ADD_COMPTEUR: 'ADD_COMPTEUR',
    SET_NUMERO_COMPTEUR: 'SET_NUMERO_COMPTEUR',
    ADD_FACTURE: 'ADD_FACTURE',
    REMOVE_FACTURE: 'REMOVE_FACTURE',
    REMOVE_COMPTEUR: 'REMOVE_COMPTEUR',
    RESET: 'RESET'
};
